import React from 'react';

export default function ErrorMessage(props) {
    if (props.error) return <h2 className="error">{props.errorMessage}</h2>
};